// extracted by mini-css-extract-plugin
export default {"wrapper":"SpiritText_wrapper__z62Pw"};